// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"344":"104e6712","375":"8bd7f56b"}[chunkId] + ".chunk.css";
};